import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/delete.png'


const _withScopeId = n => (_pushScopeId("data-v-3ea6f6cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "camera-video-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, watchEffect, onBeforeUnmount, onMounted } from 'vue';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import { useScanner } from '@/hooks/use-scanner';
import { useUserMedia } from '@vueuse/core';

interface IEmits {
  (event: 'close'): void;
  (event: 'result', data: string): void;
}


export default /*#__PURE__*/_defineComponent({
  emits: ["close", "result"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'close'): void;
  (event: 'result', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();

const video = ref<HTMLVideoElement | null>(null);

const { start, stop } = useScanner(video);
const { stream, start: startUserMedia, stop: stopUserMedia } = useUserMedia({
  constraints: {
    video: {
      facingMode: { exact: 'environment' },
      width: { ideal: 720 },
      height: { ideal: 720 },
    },
    audio: false,
  },
});

function handleVisibilityChange() {
  if (document.hidden || document.visibilityState === 'hidden') {
    handlePageHide();
  }
}

function handlePageHide() {
  close();
}

onMounted(() => {
  startUserMedia();
  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('pagehide', handlePageHide);
});

let playVideoTimer: ReturnType<typeof setTimeout>;
onBeforeUnmount(() => {
  stop();
  stopUserMedia();
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  window.removeEventListener('pagehide', handlePageHide);
  clearTimeout(playVideoTimer);
});

watchEffect(() => {
  if (video.value) {
    video.value.srcObject = stream.value || null;
    clearTimeout(playVideoTimer);
    playVideoTimer = setTimeout(() => {
      tryPlayVideo();
    }, 300);
  }
});

const showManualPlay = ref(false);
async function tryPlayVideo() {
  if (video.value && video.value.paused) {
    try {
      await video.value.play();
      showManualPlay.value = false;
    } catch (e: any) {
      if (_.get(e, 'message', '').includes('NotAllowed')) {
        showManualPlay.value = true;
      }
    }
  }
}

function close() {
  emits('close');
}

async function handleVideoPlay() {
  const result = await start();
  if (result) {
    emits('result', result);
    close();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AppIconScan = _resolveComponent("AppIconScan")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      ref_key: "video",
      ref: video,
      mute: "",
      playsinline: "",
      autoplay: "",
      onPlay: handleVideoPlay
    }, null, 544),
    _createElementVNode("div", {
      class: "btn-close",
      onClick: close
    }, _hoisted_3),
    (showManualPlay.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "muanual-play-container",
          onClick: tryPlayVideo
        }, [
          _createVNode(_component_AppIconScan),
          _hoisted_4,
          _createElementVNode("p", null, _toDisplayString(_unref(t)('click_to_scan')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})